import {Component, OnInit, Input} from '@angular/core';
import {ViewCell} from "ng2-smart-table";
import {RouterModule} from '@angular/router';

@Component({
	// selector: 'action-button-view',
	// template: '<button (click)="showAlert()">{{ renderValue }}</button>',
    template: `<a [routerLink]="['/newvulnerability', someId]" routerLinkActive="active" 
    [routerLinkActiveOptions]="{exact: true}"
    >{{ linkText }}</a>`,
})

export class CellDataRenderComp implements ViewCell, OnInit {
    // value: string | number;
    // rowData: any;
    public linkText: string;
  public someId: number;

  @Input()
  public value: string;

  @Input()
  rowData: any;

    ngOnInit(){
        this.linkText = this.value;
        //console.log("link :" +this.linkText)
    this.someId= this.rowData.VRef;
    //console.log("smeID " +this.someId);
    }
}


